import styled from 'styled-components';

export const Container = styled.div`
  // Seus estilos aqui
`;

export const Content = styled.div`
  // Seus estilos aqui
`;

export const ContainerRadioButton = styled.div`
  margin-top: 0.2rem;
  display: flex;
  align-items: center;

  .form-check {
    display: flex;
    align-items: center;
    margin-right: 1rem;
  }

  .form-check-input {
    margin-top: 0.7rem;
  }

  .form-check-label {
    margin-left: 0.5rem;
    line-height: 2rem;
    display: flex;
    align-items: center;
    margin-top: 0.7rem;
  }
`;

export const MainContainerRadioButton = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`

export const ContainerFormadioButton = styled.div`
  margin-right: 11.4%;
`
